// EAN-13 / UPC-A barcode encoding for shelf labels (no dependencies).
// A UPC-A is an EAN-13 with a leading zero, so one encoder covers both.

const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const G = ['0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'];
const R = ['1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'];
const PARITY = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

export function isValidEan13(d: string): boolean {
  if (!/^\d{13}$/.test(d)) return false;
  const sum = d.slice(0, 12).split('').reduce((s, c, i) => s + Number(c) * (i % 2 === 0 ? 1 : 3), 0);
  return (10 - (sum % 10)) % 10 === Number(d[12]);
}

/** The 13-digit EAN for a stored product code (GTIN-14 padded with zeros), or null if it cannot be drawn as EAN-13/UPC-A. */
export function toEan13(code: string): string | null {
  const digits = code.replace(/\D/g, '');
  let ean: string;
  if (digits.length === 14) { if (digits[0] !== '0') return null; ean = digits.slice(1); }
  else if (digits.length === 13) ean = digits;
  else if (digits.length === 12) ean = `0${digits}`;
  else return null;
  return isValidEan13(ean) ? ean : null;
}

/** 95 modules as a string of 1 (bar) and 0 (space): guard, 6 left digits, centre guard, 6 right digits, guard. */
export function ean13Modules(ean: string): string {
  if (!isValidEan13(ean)) throw new Error('not a valid EAN-13');
  const parity = PARITY[Number(ean[0])]!;
  let out = '101';
  for (let i = 0; i < 6; i++) out += (parity[i] === 'L' ? L : G)[Number(ean[i + 1])]!;
  out += '01010';
  for (let i = 0; i < 6; i++) out += R[Number(ean[i + 7])]!;
  return `${out}101`;
}
